/* Box style module */

import color from '../../color';

import border from './border';
import shadow from './shadow';
import size from './size';

const base = {
  backgroundColor: color.white,
  ...border().rounded,
};
const std = {
  ...base,
  ...shadow.std,
};
const stdWithTabs = {
  ...std,
  ...border().bottomRightRounded,
};
const stdPadding = size.stdPadding;

const box = {
  std,
  paddingStd: {
    padding: stdPadding,
    ...std,
  },
  stdWithTabs,
  paddingStdWithTabs: {
    padding: stdPadding,
    ...stdWithTabs,
  },
  noShadowStd: base,
  noShadowPaddingStd: {
    padding: stdPadding,
    ...base,
  },
  popover: {
    backgroundColor: color.white,
    ...border().rounded,
    ...shadow.popover,
  },
  selectedTab: {
    backgroundColor: color.white,
    ...border().topRounded,
    ...shadow.std,
  },
};

export default box;
